function validateLeaguePassClaimDayForm(){
    const form = document.querySelector('.js-league-pass-choose-mountain-form');
    const mountainField = document.querySelector('.js-league-pass-choose-mountain-field-wrapper .js-select2');
    const mountainSign = document.querySelector('.js-league-pass-choose-mountain-sign');
    
    function validateMountain(){
        if ($(mountainField).val() == '') {
            showErrorMessage(mountainSign, 'Choose mountain');
            return false;
        }

        hideErrorMessage(mountainSign);
        return true;
    }

    function showErrorMessage(element, message) {
        $(element).text(message);
        $(element).addClass('active c-alert');
        $(element).siblings('.form-item-wrap').addClass('error')
        .find('.form-item').addClass('error');
    }
    
    function hideErrorMessage(element) {
        $(element).hasClass('js-signup-password-sign')
        ? $(element).removeClass('c-alert').addClass('active c-gray-5')
        : $(element).removeClass('active c-alert');

        $(element).siblings('.form-item-wrap').removeClass('error').addClass('success')
        .find('.form-item').removeClass('error');
    }

    $(form).submit(function(e) {
        e.preventDefault();
    
        if (validateMountain()) {
            $(this).off('submit').on('submit', function(){
                return true;
            });
            $(this)[0].submit();
        } else {
            console.log('Validation failed');
        }
    });
}

runIfElementExist(validateLeaguePassClaimDayForm, '.js-league-pass-choose-mountain-form');



